import ElapsedTime from './ElapsedTime'

export default ElapsedTime
